import React from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './DraftBillingDialog.styles.scss';
import cn from 'classnames';
import { Button } from 'primereact/button';
import { AGREEMENT_TYPE } from '../../config/constants';

const DraftBillingDialog = ({ isOpen, setIsOpen, onSubmit, agreementType }) => {
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const DRAFT_EXPIRY_DAYS = 5;

  return (
    <Dialog
      focusOnShow={false}
      draggable={false}
      className={cn('rounded-4 overflow-hidden', styles.draftBillingDialog)}
      visible={isOpen}
      onHide={() => {
        setIsOpen(false);
        navigate(
          `/${i18n.language}/additional-functionalities/special-billing`,
        );
      }}
      footer={
        <Button
          onClick={() => {
            setIsOpen(false);
            navigate(
              `/${i18n.language}/additional-functionalities/special-billing`,
            );
          }}
          type="button"
          className="px-5 w-100"
          size="medium"
          label={t('common.home')}
        />
      }
    >
      <div className={styles.submissionMessage}>
        <span>
          <div>
            <i className="pi icn-check" />
          </div>
        </span>
        <h3>{t('special_billing.draft-saved-title')}</h3>
        <p>
          {t('special_billing.draft-saved-toast', {
            agreementType: t(
              `special_billing.${
                agreementType === AGREEMENT_TYPE.SELF
                  ? 'Self-billing'
                  : 'Third-Party billing'
              }`,
            ),
            days: DRAFT_EXPIRY_DAYS,
          })}
        </p>
      </div>
    </Dialog>
  );
};

export default React.memo(DraftBillingDialog);
